<ng-container *ngIf="categories.length">
  <div class="ds-grid">
    <div class="row mt-7 mb-6">
      <div class="col">
        <h2 class="ds-heading--l text-center mb-0">{{componentTexts?.headline}}</h2>
      </div>
    </div>
    <div class="row justify-content-center mt-6">
      <div class="col categories-col px-sm-0">
        <div class="row">
          <ng-container *ngFor="let category of categories;">
            <div *ngIf="!category.url" class="col-6 col-md-4">
              <div
                (click)="showProductsForCategory(category.translationKey)"
                (keydown.enter)="showProductsForCategory(category.translationKey)"
                [tabindex]="0"
                class="focusable focusable__element category-cell mb-6 ds-cursor--pointer text-center"
              >
                <div class="image-container mb-4 mb-sm-3 mx-auto">
                  <img alt="{{category.translationKey}} image"
                       src="assets/images/header/categories/{{category.translationKey}}.svg">
                </div>
                <p
                  class="ds-body d-inline-block flex-grow-1 mb-0">{{'categories.' + category.translationKey | cxTranslate}}</p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
